import React, { FC } from "react";
import {
  Container,
  Main,
  HeaderText,
  BodyWrapper,
  MailImage,
  Text1,
  Text2,
  Logo,
} from "./elements";

export type Props = {
  mailImage: string;
  logoImage: string;
  header: string;
  firstText: string;
  secondText: string;
  firstTextMobile: string;
  secondTextMobile: string;
};

const ApplicantFormSuccess: FC<Props> = (props) => {
  const { mailImage, logoImage, header } = props;

  return (
    <Main>
      <Container>
        <HeaderText>{header}</HeaderText>
        <BodyWrapper>
          <MailImage src={mailImage} alt="mail sent" />
          <Text1 {...props}>
            <span></span>
          </Text1>
          <Text2 {...props}>
            <span></span>
          </Text2>
        </BodyWrapper>
        <Logo src={logoImage} alt="logo" />
      </Container>
    </Main>
  );
};

export default ApplicantFormSuccess;
